// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-container {
    background: #f5f5f5;
    padding: 40px;
}
.job-slide-content h3 {
    font-size: 34px;
    margin-top: 15px;
}
.btn-light {
    color: #212529;
    background-color: transparent;
    border-color: transparent;
}
.job-slide-content h3::before {
    content: '';
    clip-path: polygon(64% 45%, 100% 100%, 100% 0);
    width: 95px;
    height: 55px;
    background: #f5f5f5;
    position: absolute;
    left: -90px;
    top: 20px;
}
.pre-next-btn {
    font-weight: 500;
    font-size: 40px;
}
.job-slide-content p {
    font-size: 22px;
    color: #333;
    font-weight: 500;
}
.job-slide-content a {
    font-size: 24px;
    color: #ff5800;
}
.job-text {
    font-size: 34px;
    font-weight: 500;
    text-align: left;
    color: #000;

}
.job-text::before {
    content: "";
    border-left: 5px solid #ff5800;
    padding-left: 10px;
}
/* .job-img-panel {
    margin: 64px 129px 64px 129px;
    display: flex;
    height: 614px;
} */
.slick-current .job-image-height-small {
    border: 2px solid #ff5800;
}
.job-panel-partition {
    flex: 1 1;
}

.job-img-container {
    margin-right: 10px;
    display: inline;
}

.job-img-container:hover {
    text-decoration: none;
}

.job-flex-8 {
    flex: 0.8 1 !important;
}

.job-image-height-small {
    height:145px !important;
}
.job-image {
    width: 100%;
    height: 100%;
    grid-area: 1 / 1;
    object-fit: cover;
}
a.job-img-container:hover .job-image {
    transform: scale(1.05);
    transition: all 1s;
}

a.job-img-container:hover .job-text-gradient {
    transform: scale(1.03);
    transition: all 1s;
}

.job-text-gradient {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 15px;
    text-align: left;
}
@media (max-width: 1200px) {
        .job-text {
            font-size: 24px!important;
        }
        .job-container {
            padding: 15px!important;
        }
        .job-slide-content h3 {
            font-size: 24px;
            color:#333;
        }
        .job-slide-content p {
            font-size: 18px;
        }
        .job-slide-content a {
            font-size: 18px;
        }
        .job-text-gradient {
            font-weight: 300;
            margin-bottom: 15px;
            font-size: 10px;
        }
        .pre-next-btn {
            font-size: 20px;
        }
        .job-image-height-small {
            height: 100px !important;
            width: 100% !important;
        }
        .job-slide-content {
            margin-top: 15px;
        }
    }
/* @media (max-width: 992px) {
    .job-img-panel {
        margin: 64px 0 130px 0;
        flex-direction: column;
        height: 100% !important;
    }

    .job-img-container {
        width: 100% !important;
    }

    .job-image-height {
        height: 100% !important;
    }
} */
@media (max-width: 575.98px) { 
    .job-text {
        font-size: 24px!important;
    }
    .job-container {
        padding: 15px!important;
    }
    .job-slide-content h3 {
        font-size: 24px;
        color:#333;
    }
    .job-slide-content p {
        font-size: 18px;
        display: block;
        display: -webkit-box;
        max-width: 100%;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .job-slide-content a {
        font-size: 18px;
    }
    .job-text-gradient {
        font-weight: 500;
        margin-bottom: 15px;
        font-size: 10px;
    }
    .pre-next-btn {
        font-size: 20px;
    }
    .job-image-height-small {
        height: 80px !important;
    }
    .job-slide-content {
        margin-top: 15px;
    }
    .job-header-home .card-body {
        padding-top: 0 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/home/job.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,8CAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;;AAEf;AACA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;;;;GAIG;AACH;IACI,yBAAyB;AAC7B;AACA;IACI,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;QACQ;YACI,yBAAyB;QAC7B;QACA;YACI,uBAAuB;QAC3B;QACA;YACI,eAAe;YACf,UAAU;QACd;QACA;YACI,eAAe;QACnB;QACA;YACI,eAAe;QACnB;QACA;YACI,gBAAgB;YAChB,mBAAmB;YACnB,eAAe;QACnB;QACA;YACI,eAAe;QACnB;QACA;YACI,wBAAwB;YACxB,sBAAsB;QAC1B;QACA;YACI,gBAAgB;QACpB;IACJ;AACJ;;;;;;;;;;;;;;GAcG;AACH;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,UAAU;IACd;IACA;QACI,eAAe;QACf,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,qBAAqB;QACrB,4BAA4B;QAC5B,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".job-container {\n    background: #f5f5f5;\n    padding: 40px;\n}\n.job-slide-content h3 {\n    font-size: 34px;\n    margin-top: 15px;\n}\n.btn-light {\n    color: #212529;\n    background-color: transparent;\n    border-color: transparent;\n}\n.job-slide-content h3::before {\n    content: '';\n    clip-path: polygon(64% 45%, 100% 100%, 100% 0);\n    width: 95px;\n    height: 55px;\n    background: #f5f5f5;\n    position: absolute;\n    left: -90px;\n    top: 20px;\n}\n.pre-next-btn {\n    font-weight: 500;\n    font-size: 40px;\n}\n.job-slide-content p {\n    font-size: 22px;\n    color: #333;\n    font-weight: 500;\n}\n.job-slide-content a {\n    font-size: 24px;\n    color: #ff5800;\n}\n.job-text {\n    font-size: 34px;\n    font-weight: 500;\n    text-align: left;\n    color: #000;\n\n}\n.job-text::before {\n    content: \"\";\n    border-left: 5px solid #ff5800;\n    padding-left: 10px;\n}\n/* .job-img-panel {\n    margin: 64px 129px 64px 129px;\n    display: flex;\n    height: 614px;\n} */\n.slick-current .job-image-height-small {\n    border: 2px solid #ff5800;\n}\n.job-panel-partition {\n    flex: 1;\n}\n\n.job-img-container {\n    margin-right: 10px;\n    display: inline;\n}\n\n.job-img-container:hover {\n    text-decoration: none;\n}\n\n.job-flex-8 {\n    flex: 0.8 !important;\n}\n\n.job-image-height-small {\n    height:145px !important;\n}\n.job-image {\n    width: 100%;\n    height: 100%;\n    grid-area: 1 / 1;\n    object-fit: cover;\n}\na.job-img-container:hover .job-image {\n    transform: scale(1.05);\n    transition: all 1s;\n}\n\na.job-img-container:hover .job-text-gradient {\n    transform: scale(1.03);\n    transition: all 1s;\n}\n\n.job-text-gradient {\n    font-size: 16px;\n    color: #333;\n    font-weight: 500;\n    margin-bottom: 20px;\n    margin-top: 15px;\n    text-align: left;\n}\n@media (max-width: 1200px) {\n        .job-text {\n            font-size: 24px!important;\n        }\n        .job-container {\n            padding: 15px!important;\n        }\n        .job-slide-content h3 {\n            font-size: 24px;\n            color:#333;\n        }\n        .job-slide-content p {\n            font-size: 18px;\n        }\n        .job-slide-content a {\n            font-size: 18px;\n        }\n        .job-text-gradient {\n            font-weight: 300;\n            margin-bottom: 15px;\n            font-size: 10px;\n        }\n        .pre-next-btn {\n            font-size: 20px;\n        }\n        .job-image-height-small {\n            height: 100px !important;\n            width: 100% !important;\n        }\n        .job-slide-content {\n            margin-top: 15px;\n        }\n    }\n/* @media (max-width: 992px) {\n    .job-img-panel {\n        margin: 64px 0 130px 0;\n        flex-direction: column;\n        height: 100% !important;\n    }\n\n    .job-img-container {\n        width: 100% !important;\n    }\n\n    .job-image-height {\n        height: 100% !important;\n    }\n} */\n@media (max-width: 575.98px) { \n    .job-text {\n        font-size: 24px!important;\n    }\n    .job-container {\n        padding: 15px!important;\n    }\n    .job-slide-content h3 {\n        font-size: 24px;\n        color:#333;\n    }\n    .job-slide-content p {\n        font-size: 18px;\n        display: block;\n        display: -webkit-box;\n        max-width: 100%;\n        -webkit-line-clamp: 5;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .job-slide-content a {\n        font-size: 18px;\n    }\n    .job-text-gradient {\n        font-weight: 500;\n        margin-bottom: 15px;\n        font-size: 10px;\n    }\n    .pre-next-btn {\n        font-size: 20px;\n    }\n    .job-image-height-small {\n        height: 80px !important;\n    }\n    .job-slide-content {\n        margin-top: 15px;\n    }\n    .job-header-home .card-body {\n        padding-top: 0 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
